import { useEffect, useState, useRef } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import {
  DropDownSelector,
  Checkbox,
  ButtonBasic,
} from '@lk-gtcom/ecomlab-components';
import { JoinedPromotions } from '../JoinedPromotions/JoinedPromotions';
import { ListPromotionVer2 } from '../ListPromotionVer2/ListPromotionVer2';
import { PromotionRules } from '../PromotionRules/PromotionRules';
import useGeneralStore from '../../store/general';
import './PromotionPage.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { RequestController } from '../../common/filtersFunc';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import { options_prop_mp } from '../../common/globalVariables';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { periodWeek } from '../../common/constant';
import { useSavedFilters } from '../../common/useSavedFilters';

const PromotionsPage = () => {
  const location = useLocation();
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const requestControllerRef = useRef(new RequestController());
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'promotions-page');
  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;

  // Фильтры
  const filterConfig = [
    { key: 'mp', type: 'multi' },
    { key: 'api', type: 'single' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'action', type: 'multi' }
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [actionData, setActionData] = useState([]);

  const [selectedMarketplace, setSelectedMarketplace] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedApi, setSelectedApi] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedAction, setSelectedAction] = useState([{ label: 'Все', value: 'all' }]);

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)
  const [totalAction, setTotalAction] = useState(0)

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [actionPage, setActionPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');
  const [actionQuery, setActionQuery] = useState('');

  const [isTableRequest, setIsTableRequest] = useState(false);

  const [check, setCheck] = useState(false);
  const [isModal, setIsModal] = useState(false);

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.mp) setSelectedMarketplace(urlParams.mp)
        if (urlParams.api) setSelectedApi(urlParams.api)
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.action) setSelectedAction(urlParams.waction)

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  useEffect(() => {
    if (!isReady) return;
    updateURL({
      mp: urlParams?.mp || selectedMarketplace,
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      action: urlParams?.action || selectedAction,
    })
  }, [location.pathname, isReady]);

  const apiFilter = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalApi,
      page: apiPage,
      set: setApiData,
      setApiData: setApiData,
      searchParam: apiQuery,
      selectedApi,
      selectedCategory,
      selectedBrand,
      selectedShop: selectedMarketplace,
      filter: 'api_id'
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  };

  const categoryFilter = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalCategory,
      page: categoryPage,
      apiData,
      dateFrom,
      dateTo,
      selectedApi,
      selectedCategory,
      selectedBrand,
      set: setCategoryData,
      selectedShop: selectedMarketplace,
      setCategoryData: (e) => setCategoryData(e),
      searchParam: categoryQuery,
      filter: 'category'
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const brandFilter = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalBrand,
      page: brandPage,
      apiData,
      categoryData,
      selectedApi,
      selectedCategory,
      selectedBrand,
      selectedShop: selectedMarketplace,
      dateFrom,
      dateTo,
      searchParam: brandQuery,
      setBrandData: (e) => setBrandData(e),
      set: setBrandData,
      filter: 'brand'
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  const actionFilter = () => {
    const controller = requestControllerRef.current.createController('action');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalAction,
      page: actionPage,
      apiData,
      categoryData,
      selectedApi,
      selectedCategory,
      selectedBrand,
      selectedShop: selectedMarketplace,
      dateFrom,
      dateTo,
      searchParam: actionQuery,
      set: setActionData,
      filter: 'action'
    })?.finally(() => {
      requestControllerRef.current.removeController('action');
    })
  };

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    apiFilter();
  }, [isFilterRequest, apiPage, apiQuery, date]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    categoryFilter();
  }, [isFilterRequest, categoryPage, categoryQuery, date]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    brandFilter();
  }, [isFilterRequest, brandPage, brandQuery, date]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    actionFilter();
  }, [isFilterRequest, actionPage, actionQuery]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  const getTitle = () => {
    if (location.pathname.includes('joined-promotions'))
      return 'Товары в акции';
    if (location.pathname.includes('list-promotion')) return 'Список акций';
    if (location.pathname.includes('promotion-rules')) return 'Правила';
  };

  const filters = (
    <div className="promotion-page__filters">
      <FilterContainer
        loading={isSaved}
        saveFilters={saveFilters}
        clearSavedFilters={clearSavedFilters}
        hasSavedFilters={hasSavedFilters}
        onReset={() => {
          setSelectedMarketplace([])
          setSelectedApi([])
          setSelectedBrand([])
          setSelectedCategory([])
          setSelectedAction([])
          updateURL({
            mp: null,
            api: null,
            category: null,
            brand: null,
            action: null
          });
          setIsFilterRequest(!isFilterRequest);
          setIsTableRequest(!isTableRequest)
        }}
      >
        <DropDownSelector
          options_prop={options_prop_mp}
          state={selectedMarketplace}
          setState={setSelectedMarketplace}
          placeholder="Площадка"
          total={options_prop_mp?.length}
          multi
          onBlur={() => {
            updateURL({ mp: selectedMarketplace });
            apiFilter()
            brandFilter()
            categoryFilter()
            actionFilter()
            setIsTableRequest(!isTableRequest)
          }}
        />

        <DropDownSelector
          options_prop={apiData}
          state={selectedApi}
          setState={setSelectedApi}
          placeholder="Магазин"
          total={totalApi}
          fetchCallback={setApiPage}
          setInputChange={setApiQuery}
          onBlur={() => {
            updateURL({ api: selectedApi });
            brandFilter()
            categoryFilter()
            actionFilter()
            setIsTableRequest(!isTableRequest)
          }}
        />

        <DropDownSelector
          options_prop={categoryData}
          state={selectedCategory}
          setState={setSelectedCategory}
          placeholder="Категория"
          total={totalCategory}
          fetchCallback={setCategoryPage}
          setInputChange={setCategoryQuery}
          multi
          onBlur={() => {
            updateURL({ category: selectedCategory });
            brandFilter()
            actionFilter()
            setIsTableRequest(!isTableRequest)
          }}
        />

        <DropDownSelector
          options_prop={brandData}
          state={selectedBrand}
          setState={setSelectedBrand}
          placeholder="Бренд"
          total={totalBrand}
          fetchCallback={setBrandPage}
          setInputChange={setBrandQuery}
          multi
          onBlur={() => {
            updateURL({ brand: selectedBrand });
            actionFilter()
            setIsTableRequest(!isTableRequest)
          }}
        />

        {location.pathname.includes('joined-promotions') && (
          <DropDownSelector
            options_prop={actionData}
            state={selectedAction}
            setState={setSelectedAction}
            placeholder="Акции"
            total={totalAction}
            fetchCallback={setActionPage}
            setInputChange={setActionQuery}
            multi
            onBlur={() => {
              updateURL({ action: selectedAction });
              setIsTableRequest(!isTableRequest)
            }}
          />
        )}

        {location.pathname.includes('joined-promotions') && (
          <Checkbox value={check}
            onChange={() => setCheck(!check)}>
            Без 0 остатков
          </Checkbox>
        )}
      </FilterContainer>

      <div className="promotion_page_-group-btn">
        {location.pathname.includes('promotion-rules') && (
          <ButtonBasic
            green
            onClick={() => setIsModal(true)}
            width="auto"
            text="Добавить правило +"
          />
        )}
      </div>
    </div>
  );

  return (
    <div className="promotion-page">
      <TitlePage
        title={getTitle()}
      />
      {filters}
      <Routes>
        <Route
          path="joined-promotions/*"
          element={
            <JoinedPromotions
              isTableRequest={isTableRequest}
              setIsTableRequest={setIsTableRequest}
              selectedMarketplace={selectedMarketplace}
              selectedApi={selectedApi}
              selectedCategory={selectedCategory}
              selectedBrand={selectedBrand}
              selectedAction={selectedAction}
              check={check}
              isReady={isReady}
            />
          }
        />
        <Route
          path="list-promotion/*"
          element={
            <ListPromotionVer2
              isTableRequest={isTableRequest}
              setShowTooltipLauncAdvertisingCampaign={() => { }}
              selectedMarketplace={selectedMarketplace}
              selectedApi={selectedApi}
              selectedCategory={selectedCategory}
              selectedBrand={selectedBrand}
              isReady={isReady}
            />
          }
        />
        <Route
          path="promotion-rules/*"
          element={
            <PromotionRules
              isTableRequest={isTableRequest}
              isModal={isModal}
              setIsModal={setIsModal}
              selectedMarketplace={selectedMarketplace}
              selectedApi={selectedApi}
              selectedCategory={selectedCategory}
              selectedBrand={selectedBrand}
              isReady={isReady}
            />
          }
        />
      </Routes>
    </div>
  );
};

export { PromotionsPage };
